const PRIME_GREEN = "#42B48B";
const SALMON = "#ED7879";
const VIRIDIAN = "#0E7586";
const PRIME_YELLOW = "#F3A446";
const DULL_BLUE = "#79B3CC";
const JOCKEY = "#3DD3B0";
const INDIGO = "#5636B3";
const BEEF = "#8B3435";
const DOLPHIN = "#67697A";
const LAVANDER = "#917CCE";
const PRIME_RED = "#E85658";
const COPPER = "#C28338";
const colors = [
  PRIME_GREEN,
  SALMON,
  VIRIDIAN,
  DULL_BLUE,
  JOCKEY,
  INDIGO,
  BEEF,
  DOLPHIN,
  LAVANDER,
  PRIME_GREEN,
  PRIME_RED,
  PRIME_YELLOW,
  COPPER,
];

const colorDefine = (id: string): string => {
  const colorIndex = id
    .split("")
    .reduce((prev, curr) => (prev += curr.charCodeAt(0)), 0);
  const approved =
    colorIndex > colors.length - 1
      ? colorIndex - Math.floor(colorIndex / colors.length) * colors.length
      : colorIndex;
  return colors[approved];
};
const textDefine = (
  email: string,
  firstName: string,
  lastName: string,
  id: string
): string => {
  const text =
    firstName && lastName
      ? firstName.slice(0, 1) + lastName.slice(0, 1)
      : email
      ? email.slice(0, 1)
      : id.slice(0, 1);
  return text;
};

export type ReturnAvatar = {
  backgroundImage?: string;
  text?: string;
  color?: string;
};
export const useAvatar = ({
  picture,
  email,
  firstName,
  lastName,
  id,
}: {
  picture: string;
  email: string;
  firstName: string;
  lastName: string;
  id: string;
}): ReturnAvatar => {
  try {
    if (
      picture === undefined ||
      picture === null ||
      firstName === undefined ||
      lastName === undefined ||
      id === undefined
    )
      return { backgroundImage: undefined, text: "", color: "#dddddd" };
    const actualPicture =
      picture?.indexOf("s.gravatar") === -1 &&
      picture?.indexOf("cdn.auth0") === -1
        ? picture
        : "";
    if (actualPicture !== "") return { backgroundImage: actualPicture };
    const text = textDefine(email, firstName, lastName, id);
    const color = colorDefine(id);
    return { text, color, backgroundImage: undefined };
  } catch (e) {
    console.log("error in useAvatar", picture, email, firstName, lastName, id);
    return { backgroundImage: undefined, text: "", color: "#dddddd" };
  }
};
